// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Register.css — KinetiQ Registration Page
   Mirrors Login.css layout exactly:
     • Fixed navbar clearance at top (padding-top: 68px on shell)
     • Two-column split: dark left panel + light right card
     • The WHOLE PAGE scrolls (browser scrollbar), and the
       footer sits at the end of the page.
   ============================================================ */

/* ── Page shell ─────────────────────────────────────────────
   min-height (not height) so the page can grow past the viewport
   and scroll normally. overflow must stay visible so the
   position:fixed navbar is never clipped by a parent.         */
.reg-shell {
  position: fixed;               /* own scroll container: independent of html/body CSS */
  top: 68px;                     /* starts right below the 68px fixed navbar           */
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;              /* <-- the whole page (content + footer) scrolls here */
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  box-sizing: border-box;
}

/* ── Two-column content area ──
   flex: 1 → fills the space above the footer on tall screens,
   so the footer is pushed to the bottom of the viewport.      */
.reg-page {
  display: grid;
  grid-template-columns: 1fr 1fr;
  flex: 1 0 auto;
}

/* ════════════════════════════════════════════════════════════
   LEFT PANEL — dark gradient (identical to Login)
   ════════════════════════════════════════════════════════════ */
.reg-left {
  background: linear-gradient(160deg, #1A3C6E 0%, #0E2A52 55%, #0D1F35 100%);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 52px 52px 44px;
  position: relative;
  overflow: hidden;           /* only clips the decorative bubble */
  color: #FFFFFF;
}

/* Radial teal glow overlay */
.reg-left::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 70% 60% at 75% 40%, rgba(0,194,168,0.12) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
}

/* Decorative bottom-left bubble */
.reg-left::after {
  content: '';
  position: absolute;
  width: 280px;
  height: 280px;
  border-radius: 50%;
  background: rgba(0,194,168,0.06);
  bottom: -80px;
  left: -60px;
  pointer-events: none;
  z-index: 0;
}

.reg-left > * { position: relative; z-index: 1; }

/* ── Left panel hero copy ── */
.reg-hero-copy {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 22px;
}

/* Badge */
.reg-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(0,194,168,0.15);
  border: 1px solid rgba(0,194,168,0.35);
  color: #00C2A8;
  font-size: 0.76rem;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  padding: 6px 14px;
  border-radius: 99px;
  width: fit-content;
}

.reg-badge::before {
  content: '';
  width: 7px;
  height: 7px;
  background: #00C2A8;
  border-radius: 50%;
  flex-shrink: 0;
  animation: reg-pulse 2s ease-in-out infinite;
}

@keyframes reg-pulse {
  0%, 100% { opacity: 1;   transform: scale(1);   }
  50%       { opacity: 0.5; transform: scale(1.4); }
}

.reg-hero-copy h1 {
  font-size: clamp(1.7rem, 2.8vw, 2.4rem);
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: -0.025em;
  color: #FFFFFF;
}

.reg-hero-copy h1 em {
  font-style: normal;
  color: #00C2A8;
}

.reg-hero-copy p {
  font-size: 0.97rem;
  color: rgba(255,255,255,0.72);
  line-height: 1.72;
  max-width: 400px;
}

/* Feature checklist */
.reg-feature-list {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 13px;
  margin-top: 4px;
}

.reg-feature-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
  color: rgba(255,255,255,0.82);
}

.reg-feature-list li .check {
  width: 22px;
  height: 22px;
  background: #00C2A8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.68rem;
  color: #0D1F35;
  font-weight: 800;
}

/* Web pill */
.reg-web-pill {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 99px;
  padding: 8px 16px 8px 10px;
  font-size: 0.82rem;
  color: rgba(255,255,255,0.65);
  width: fit-content;
  margin-top: 28px;
}

.reg-web-pill .pill-icon {
  width: 26px;
  height: 26px;
  background: #00C2A8;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  flex-shrink: 0;
}

/* ════════════════════════════════════════════════════════════
   RIGHT PANEL — form area
   ════════════════════════════════════════════════════════════ */
.reg-right {
  background: #F4F8FB;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 32px 32px 40px;
}

/* ── Card ── */
.reg-card {
  width: 100%;
  max-width: 480px;             /* slightly wider than login — more fields */
  background: #FFFFFF;
  border: 1.5px solid #B8D4E0;
  border-radius: 20px;
  padding: 40px 40px 36px;
  box-shadow: 0 8px 48px rgba(10,50,90,0.13);
}

/* ── Card header ── */
.reg-card-header {
  margin-bottom: 20px;
}

.reg-card-label {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: #0B8DA6;
  margin-bottom: 8px;
}

.reg-card-header h2 {
  font-size: 1.75rem;
  font-weight: 800;
  color: #1A3C6E;
  line-height: 1.15;
  letter-spacing: -0.022em;
  margin-bottom: 6px;
}

.reg-card-header p {
  font-size: 0.9rem;
  color: #6B7A8D;
  line-height: 1.6;
}

/* ── Restricted access info banner ── */
.reg-info-banner {
  display: flex;
  gap: 10px;
  align-items: flex-start;
  background: rgba(255,193,7,0.08);
  border: 1px solid rgba(255,193,7,0.35);
  border-radius: 8px;
  padding: 12px 14px;
  margin-bottom: 20px;
}

.reg-info-icon {
  font-size: 1rem;
  flex-shrink: 0;
  margin-top: 1px;
}

.reg-info-banner p {
  margin: 0;
  font-size: 0.82rem;
  color: #7a5c00;
  line-height: 1.55;
}

/* ── Error banner ── */
.reg-error {
  background: rgba(244,162,97,0.11);
  border: 1px solid rgba(244,162,97,0.45);
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 0.85rem;
  color: #b85e1a;
  font-weight: 500;
  margin-bottom: 18px;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.45;
}

.reg-error::before {
  content: '⚠';
  font-size: 1rem;
  flex-shrink: 0;
}

/* ── Form ── */
.reg-form {
  display: flex;
  flex-direction: column;
}

/* Two-column name row */
.reg-name-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

/* Form group */
.reg-form-group {
  margin-bottom: 16px;
}

.reg-form-group label {
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
  color: #1A3C6E;
  margin-bottom: 7px;
  letter-spacing: 0.02em;
}

/* "(optional)" hint beside a label */
.reg-optional {
  font-weight: 400;
  color: #9BAABB;
  font-size: 0.78rem;
}

/* Inputs — same as Login */
.reg-form-group input[type="text"],
.reg-form-group input[type="email"],
.reg-form-group input[type="password"] {
  display: block;
  width: 100%;
  background: #EBF4F8;
  border: 1.5px solid #B8D4E0;
  border-radius: 6px;
  padding: 12px 14px;
  color: #0D1F35;
  font-size: 0.93rem;
  font-family: 'Inter', 'Segoe UI', sans-serif;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.18s, background 0.18s, box-shadow 0.18s;
  -webkit-appearance: none;
}

.reg-form-group input::placeholder {
  color: #9BAABB;
  font-size: 0.88rem;
}

.reg-form-group input:hover {
  border-color: #0B8DA6;
}

.reg-form-group input:focus {
  border-color: #0B8DA6;
  background: #FFFFFF;
  box-shadow: 0 0 0 3px rgba(11,141,166,0.13);
}

/* ── Role selector section (currently unused in Register.js) ── */
.reg-role-section {
  margin-bottom: 18px;
}

.reg-role-label {
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
  color: #1A3C6E;
  letter-spacing: 0.02em;
  margin-bottom: 10px;
}

.reg-role-option {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 13px 14px;
  background: #EBF4F8;
  border: 1.5px solid #B8D4E0;
  border-radius: 8px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: border-color 0.18s, background 0.18s, box-shadow 0.18s;
}

.reg-role-option:hover {
  border-color: #0B8DA6;
  background: #e0f0f6;
}

.reg-role-option.selected {
  border-color: #00C2A8;
  background: rgba(0,194,168,0.06);
  box-shadow: 0 0 0 3px rgba(0,194,168,0.12);
}

.reg-role-option input[type="radio"] {
  width: 16px;
  height: 16px;
  margin-top: 3px;
  flex-shrink: 0;
  accent-color: #00C2A8;
  cursor: pointer;
}

.reg-role-text {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.reg-role-name {
  font-size: 0.88rem;
  font-weight: 600;
  color: #1A3C6E;
}

.reg-role-desc {
  font-size: 0.79rem;
  color: #6B7A8D;
  line-height: 1.45;
}

.reg-role-note {
  font-size: 0.76rem;
  color: #9BAABB;
  line-height: 1.55;
  margin-top: 6px;
}

/* ── Submit button ── */
.reg-submit-btn {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #00C2A8;
  color: #0D1F35;
  font-weight: 700;
  font-size: 0.97rem;
  padding: 15px 28px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
  box-shadow: 0 4px 18px rgba(0,194,168,0.32);
  font-family: 'Inter', 'Segoe UI', sans-serif;
  margin-top: 4px;
  letter-spacing: 0.01em;
}

.reg-submit-btn:hover {
  background: #00a896;
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0,194,168,0.42);
}

.reg-submit-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0,194,168,0.25);
}

/* ── Divider ── */
.reg-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 20px 0;
  color: #6B7A8D;
  font-size: 0.8rem;
}

.reg-divider::before,
.reg-divider::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: #B8D4E0;
}

/* ── Sign-in row ── */
.reg-login-row {
  text-align: center;
  font-size: 0.9rem;
  color: #6B7A8D;
  margin: 0;
}

.reg-login-row a {
  color: #0B8DA6;
  font-weight: 600;
  text-decoration: none;
  transition: color 0.2s;
}

.reg-login-row a:hover {
  color: #1A3C6E;
  text-decoration: underline;
}

/* ════════════════════════════════════════════════════════════
   SUCCESS STATE
   ════════════════════════════════════════════════════════════ */
.reg-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 16px 0 8px;
  gap: 16px;
}

.reg-success-icon {
  font-size: 3rem;
  line-height: 1;
}

.reg-success-title {
  font-size: 1.5rem;
  font-weight: 800;
  color: #00C2A8;
  margin: 0;
  letter-spacing: -0.02em;
}

.reg-success-text {
  font-size: 0.9rem;
  color: #6B7A8D;
  line-height: 1.65;
  max-width: 360px;
  margin: 0;
}

.reg-success-text strong {
  color: #1A3C6E;
}

/* ════════════════════════════════════════════════════════════
   RESPONSIVE
   ════════════════════════════════════════════════════════════ */
@media (max-width: 860px) {
  .reg-page {
    grid-template-columns: 1fr;
  }

  .reg-left {
    display: none;
  }

  .reg-right {
    background: linear-gradient(160deg, #1A3C6E 0%, #0E2A52 55%, #0D1F35 100%);
    padding: 32px 20px 48px;
  }

  .reg-card {
    border: none;
    box-shadow: 0 12px 48px rgba(0,0,0,0.25);
  }
}

@media (max-width: 520px) {
  .reg-name-row {
    grid-template-columns: 1fr;  /* stack names vertically on small screens */
    gap: 0;
  }

  .reg-card {
    padding: 28px 20px 24px;
    border-radius: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Register.css"],"names":[],"mappings":"AAAA;;;;;;;iEAOiE;;AAEjE;;;gEAGgE;AAChE;EACE,eAAe,gBAAgB,uDAAuD;EACtF,SAAS,sBAAsB,uDAAuD;EACtF,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB,eAAe,uDAAuD;EACtF,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;;gEAEgE;AAChE;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;;iEAEiE;AACjE;EACE,0EAA0E;EAC1E,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB,YAAY,qCAAqC;EACjE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,iGAAiG;EACjG,oBAAoB;EACpB,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,UAAU;AACZ;;AAEA,gBAAgB,kBAAkB,EAAE,UAAU,EAAE;;AAEhD,+BAA+B;AAC/B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gCAAgC;EAChC,sCAAsC;EACtC,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,WAAW,UAAU,IAAI,mBAAmB,IAAI;EAChD,YAAY,YAAY,EAAE,qBAAqB,EAAE;AACnD;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;;iEAEiE;AACjE;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA,eAAe;AACf;EACE,WAAW;EACX,gBAAgB,cAAc,4CAA4C;EAC1E,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,gCAAgC;EAChC,sCAAsC;EACtC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,qCAAqC;AACrC;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;;;EAGE,cAAc;EACd,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;EACtB,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,kEAAkE;AAClE;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;EAChC,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,6DAA6D;EAC7D,2CAA2C;EAC3C,4CAA4C;EAC5C,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;;iEAEiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;;iEAEiE;AACjE;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0EAA0E;IAC1E,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,wCAAwC;EAC1C;AACF;;AAEA;EACE;IACE,0BAA0B,GAAG,4CAA4C;IACzE,MAAM;EACR;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;AACF","sourcesContent":["/* ============================================================\n   Register.css — KinetiQ Registration Page\n   Mirrors Login.css layout exactly:\n     • Fixed navbar clearance at top (padding-top: 68px on shell)\n     • Two-column split: dark left panel + light right card\n     • The WHOLE PAGE scrolls (browser scrollbar), and the\n       footer sits at the end of the page.\n   ============================================================ */\n\n/* ── Page shell ─────────────────────────────────────────────\n   min-height (not height) so the page can grow past the viewport\n   and scroll normally. overflow must stay visible so the\n   position:fixed navbar is never clipped by a parent.         */\n.reg-shell {\n  position: fixed;               /* own scroll container: independent of html/body CSS */\n  top: 68px;                     /* starts right below the 68px fixed navbar           */\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow-y: auto;              /* <-- the whole page (content + footer) scrolls here */\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: column;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  box-sizing: border-box;\n}\n\n/* ── Two-column content area ──\n   flex: 1 → fills the space above the footer on tall screens,\n   so the footer is pushed to the bottom of the viewport.      */\n.reg-page {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  flex: 1 0 auto;\n}\n\n/* ════════════════════════════════════════════════════════════\n   LEFT PANEL — dark gradient (identical to Login)\n   ════════════════════════════════════════════════════════════ */\n.reg-left {\n  background: linear-gradient(160deg, #1A3C6E 0%, #0E2A52 55%, #0D1F35 100%);\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 52px 52px 44px;\n  position: relative;\n  overflow: hidden;           /* only clips the decorative bubble */\n  color: #FFFFFF;\n}\n\n/* Radial teal glow overlay */\n.reg-left::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(ellipse 70% 60% at 75% 40%, rgba(0,194,168,0.12) 0%, transparent 70%);\n  pointer-events: none;\n  z-index: 0;\n}\n\n/* Decorative bottom-left bubble */\n.reg-left::after {\n  content: '';\n  position: absolute;\n  width: 280px;\n  height: 280px;\n  border-radius: 50%;\n  background: rgba(0,194,168,0.06);\n  bottom: -80px;\n  left: -60px;\n  pointer-events: none;\n  z-index: 0;\n}\n\n.reg-left > * { position: relative; z-index: 1; }\n\n/* ── Left panel hero copy ── */\n.reg-hero-copy {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 22px;\n}\n\n/* Badge */\n.reg-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(0,194,168,0.15);\n  border: 1px solid rgba(0,194,168,0.35);\n  color: #00C2A8;\n  font-size: 0.76rem;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  padding: 6px 14px;\n  border-radius: 99px;\n  width: fit-content;\n}\n\n.reg-badge::before {\n  content: '';\n  width: 7px;\n  height: 7px;\n  background: #00C2A8;\n  border-radius: 50%;\n  flex-shrink: 0;\n  animation: reg-pulse 2s ease-in-out infinite;\n}\n\n@keyframes reg-pulse {\n  0%, 100% { opacity: 1;   transform: scale(1);   }\n  50%       { opacity: 0.5; transform: scale(1.4); }\n}\n\n.reg-hero-copy h1 {\n  font-size: clamp(1.7rem, 2.8vw, 2.4rem);\n  font-weight: 800;\n  line-height: 1.15;\n  letter-spacing: -0.025em;\n  color: #FFFFFF;\n}\n\n.reg-hero-copy h1 em {\n  font-style: normal;\n  color: #00C2A8;\n}\n\n.reg-hero-copy p {\n  font-size: 0.97rem;\n  color: rgba(255,255,255,0.72);\n  line-height: 1.72;\n  max-width: 400px;\n}\n\n/* Feature checklist */\n.reg-feature-list {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 13px;\n  margin-top: 4px;\n}\n\n.reg-feature-list li {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.9rem;\n  color: rgba(255,255,255,0.82);\n}\n\n.reg-feature-list li .check {\n  width: 22px;\n  height: 22px;\n  background: #00C2A8;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  font-size: 0.68rem;\n  color: #0D1F35;\n  font-weight: 800;\n}\n\n/* Web pill */\n.reg-web-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  background: rgba(255,255,255,0.07);\n  border: 1px solid rgba(255,255,255,0.15);\n  border-radius: 99px;\n  padding: 8px 16px 8px 10px;\n  font-size: 0.82rem;\n  color: rgba(255,255,255,0.65);\n  width: fit-content;\n  margin-top: 28px;\n}\n\n.reg-web-pill .pill-icon {\n  width: 26px;\n  height: 26px;\n  background: #00C2A8;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.85rem;\n  flex-shrink: 0;\n}\n\n/* ════════════════════════════════════════════════════════════\n   RIGHT PANEL — form area\n   ════════════════════════════════════════════════════════════ */\n.reg-right {\n  background: #F4F8FB;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 32px 32px 40px;\n}\n\n/* ── Card ── */\n.reg-card {\n  width: 100%;\n  max-width: 480px;             /* slightly wider than login — more fields */\n  background: #FFFFFF;\n  border: 1.5px solid #B8D4E0;\n  border-radius: 20px;\n  padding: 40px 40px 36px;\n  box-shadow: 0 8px 48px rgba(10,50,90,0.13);\n}\n\n/* ── Card header ── */\n.reg-card-header {\n  margin-bottom: 20px;\n}\n\n.reg-card-label {\n  display: inline-block;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n  color: #0B8DA6;\n  margin-bottom: 8px;\n}\n\n.reg-card-header h2 {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: #1A3C6E;\n  line-height: 1.15;\n  letter-spacing: -0.022em;\n  margin-bottom: 6px;\n}\n\n.reg-card-header p {\n  font-size: 0.9rem;\n  color: #6B7A8D;\n  line-height: 1.6;\n}\n\n/* ── Restricted access info banner ── */\n.reg-info-banner {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n  background: rgba(255,193,7,0.08);\n  border: 1px solid rgba(255,193,7,0.35);\n  border-radius: 8px;\n  padding: 12px 14px;\n  margin-bottom: 20px;\n}\n\n.reg-info-icon {\n  font-size: 1rem;\n  flex-shrink: 0;\n  margin-top: 1px;\n}\n\n.reg-info-banner p {\n  margin: 0;\n  font-size: 0.82rem;\n  color: #7a5c00;\n  line-height: 1.55;\n}\n\n/* ── Error banner ── */\n.reg-error {\n  background: rgba(244,162,97,0.11);\n  border: 1px solid rgba(244,162,97,0.45);\n  border-radius: 6px;\n  padding: 10px 14px;\n  font-size: 0.85rem;\n  color: #b85e1a;\n  font-weight: 500;\n  margin-bottom: 18px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  line-height: 1.45;\n}\n\n.reg-error::before {\n  content: '⚠';\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n/* ── Form ── */\n.reg-form {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Two-column name row */\n.reg-name-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n}\n\n/* Form group */\n.reg-form-group {\n  margin-bottom: 16px;\n}\n\n.reg-form-group label {\n  display: block;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #1A3C6E;\n  margin-bottom: 7px;\n  letter-spacing: 0.02em;\n}\n\n/* \"(optional)\" hint beside a label */\n.reg-optional {\n  font-weight: 400;\n  color: #9BAABB;\n  font-size: 0.78rem;\n}\n\n/* Inputs — same as Login */\n.reg-form-group input[type=\"text\"],\n.reg-form-group input[type=\"email\"],\n.reg-form-group input[type=\"password\"] {\n  display: block;\n  width: 100%;\n  background: #EBF4F8;\n  border: 1.5px solid #B8D4E0;\n  border-radius: 6px;\n  padding: 12px 14px;\n  color: #0D1F35;\n  font-size: 0.93rem;\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.18s, background 0.18s, box-shadow 0.18s;\n  -webkit-appearance: none;\n}\n\n.reg-form-group input::placeholder {\n  color: #9BAABB;\n  font-size: 0.88rem;\n}\n\n.reg-form-group input:hover {\n  border-color: #0B8DA6;\n}\n\n.reg-form-group input:focus {\n  border-color: #0B8DA6;\n  background: #FFFFFF;\n  box-shadow: 0 0 0 3px rgba(11,141,166,0.13);\n}\n\n/* ── Role selector section (currently unused in Register.js) ── */\n.reg-role-section {\n  margin-bottom: 18px;\n}\n\n.reg-role-label {\n  display: block;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #1A3C6E;\n  letter-spacing: 0.02em;\n  margin-bottom: 10px;\n}\n\n.reg-role-option {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 13px 14px;\n  background: #EBF4F8;\n  border: 1.5px solid #B8D4E0;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  cursor: pointer;\n  transition: border-color 0.18s, background 0.18s, box-shadow 0.18s;\n}\n\n.reg-role-option:hover {\n  border-color: #0B8DA6;\n  background: #e0f0f6;\n}\n\n.reg-role-option.selected {\n  border-color: #00C2A8;\n  background: rgba(0,194,168,0.06);\n  box-shadow: 0 0 0 3px rgba(0,194,168,0.12);\n}\n\n.reg-role-option input[type=\"radio\"] {\n  width: 16px;\n  height: 16px;\n  margin-top: 3px;\n  flex-shrink: 0;\n  accent-color: #00C2A8;\n  cursor: pointer;\n}\n\n.reg-role-text {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.reg-role-name {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: #1A3C6E;\n}\n\n.reg-role-desc {\n  font-size: 0.79rem;\n  color: #6B7A8D;\n  line-height: 1.45;\n}\n\n.reg-role-note {\n  font-size: 0.76rem;\n  color: #9BAABB;\n  line-height: 1.55;\n  margin-top: 6px;\n}\n\n/* ── Submit button ── */\n.reg-submit-btn {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  background: #00C2A8;\n  color: #0D1F35;\n  font-weight: 700;\n  font-size: 0.97rem;\n  padding: 15px 28px;\n  border-radius: 6px;\n  border: none;\n  cursor: pointer;\n  transition: background 0.2s, transform 0.15s, box-shadow 0.2s;\n  box-shadow: 0 4px 18px rgba(0,194,168,0.32);\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  margin-top: 4px;\n  letter-spacing: 0.01em;\n}\n\n.reg-submit-btn:hover {\n  background: #00a896;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(0,194,168,0.42);\n}\n\n.reg-submit-btn:active {\n  transform: translateY(0);\n  box-shadow: 0 2px 8px rgba(0,194,168,0.25);\n}\n\n/* ── Divider ── */\n.reg-divider {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin: 20px 0;\n  color: #6B7A8D;\n  font-size: 0.8rem;\n}\n\n.reg-divider::before,\n.reg-divider::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: #B8D4E0;\n}\n\n/* ── Sign-in row ── */\n.reg-login-row {\n  text-align: center;\n  font-size: 0.9rem;\n  color: #6B7A8D;\n  margin: 0;\n}\n\n.reg-login-row a {\n  color: #0B8DA6;\n  font-weight: 600;\n  text-decoration: none;\n  transition: color 0.2s;\n}\n\n.reg-login-row a:hover {\n  color: #1A3C6E;\n  text-decoration: underline;\n}\n\n/* ════════════════════════════════════════════════════════════\n   SUCCESS STATE\n   ════════════════════════════════════════════════════════════ */\n.reg-success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 16px 0 8px;\n  gap: 16px;\n}\n\n.reg-success-icon {\n  font-size: 3rem;\n  line-height: 1;\n}\n\n.reg-success-title {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: #00C2A8;\n  margin: 0;\n  letter-spacing: -0.02em;\n}\n\n.reg-success-text {\n  font-size: 0.9rem;\n  color: #6B7A8D;\n  line-height: 1.65;\n  max-width: 360px;\n  margin: 0;\n}\n\n.reg-success-text strong {\n  color: #1A3C6E;\n}\n\n/* ════════════════════════════════════════════════════════════\n   RESPONSIVE\n   ════════════════════════════════════════════════════════════ */\n@media (max-width: 860px) {\n  .reg-page {\n    grid-template-columns: 1fr;\n  }\n\n  .reg-left {\n    display: none;\n  }\n\n  .reg-right {\n    background: linear-gradient(160deg, #1A3C6E 0%, #0E2A52 55%, #0D1F35 100%);\n    padding: 32px 20px 48px;\n  }\n\n  .reg-card {\n    border: none;\n    box-shadow: 0 12px 48px rgba(0,0,0,0.25);\n  }\n}\n\n@media (max-width: 520px) {\n  .reg-name-row {\n    grid-template-columns: 1fr;  /* stack names vertically on small screens */\n    gap: 0;\n  }\n\n  .reg-card {\n    padding: 28px 20px 24px;\n    border-radius: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
